export default function documentsService($http, RESOURCES) {
  var documentsUrl = '/documents';

  function getDocuments(merchantId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + documentsUrl);
  }

  function getDocumentById(merchantId, documentId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + documentsUrl + '/' + documentId);
  }

  function addDocument(merchantId, data, file) {
    var formData = new FormData();
    formData.append('documentDto', new Blob([angular.toJson(data)], { type: 'application/json' }));
    formData.append('multipartFile', file);

    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + documentsUrl, formData, {
      transformRequest: angular.identity,
      headers: {
        'Content-Type': undefined,
      },
    });
  }

  function updateDocument(merchantId, data, file) {
    var formData = new FormData();
    formData.append('documentDto', new Blob([angular.toJson(data)], { type: 'application/json' }));
    if (file) {
      formData.append('multipartFile', file);
    }
    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + documentsUrl + '/update', formData, {
      transformRequest: angular.identity,
      headers: {
        'Content-Type': undefined,
      },
    });
  }

  function deleteDocument(merchantId, documentId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + documentsUrl + '/' + documentId);
  }

  function getDocumentCategories() {
    return $http.get(RESOURCES.DOCUMENT_CATEGORIES);
  }

  function updateSortOrder(merchantId, documentId, index) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + documentsUrl + '/' + documentId, { index: index });
  }

  return {
    getDocuments: getDocuments,
    getDocumentById: getDocumentById,
    addDocument: addDocument,
    updateDocument: updateDocument,
    deleteDocument: deleteDocument,
    getDocumentCategories: getDocumentCategories,
    updateSortOrder: updateSortOrder,
  };
}



// WEBPACK FOOTER //
// ./src/app/merchants/documents/documents.service.js